import FoundationComponent from './foundation/index';

/**
 * Re-export the refactored Foundation component
 * This preserves backward compatibility while using the refactored implementation
 */
export default FoundationComponent;